<template>
  <!-- begin::Scrolltop -->
  <div id="kt_scrolltop" ref="kt_scrolltop" class="scrolltop">
    <ArrowUp :size="20" class="text-white" />
  </div>
  <!-- end::Scrolltop -->
</template>

<script>
import KTLayoutScrolltop from '@/assets/js/layout/extended/scrolltop.js';
import { ArrowUp } from 'lucide-vue';

export default {
  name: 'KTScrollTop',
  components: { ArrowUp },
  mounted() {
    // Init Scrolltop
    KTLayoutScrolltop.init(this.$refs['kt_scrolltop']);
  },
};
</script>
